import { render, staticRenderFns } from "./Ended.vue?vue&type=template&id=57be8422&scoped=true&"
import script from "./Ended.vue?vue&type=script&lang=js&"
export * from "./Ended.vue?vue&type=script&lang=js&"
import style0 from "./Ended.vue?vue&type=style&index=0&id=57be8422&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57be8422",
  null
  
)

export default component.exports